import { render } from "./RegistGroupClass.vue?vue&type=template&id=340447ce"
import script from "./RegistGroupClass.vue?vue&type=script&lang=js"
export * from "./RegistGroupClass.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__